<template>
    <section class="pb-4 pb-md-5">
        <div class="container-lg">
            <div class="row d-flex justify-content-center align-items-center">
                <div
                    class="col-md-6 mb-4 mb-md-0"
                    data-aos="fade-in"
                    data-aos-once="true"
                    data-wow-duration="1000"
                >
                    <img
                        src="/assets/custom/img/organic.jpg"
                        data-src="/assets/custom/img/organic.jpg"
                        width="635"
                        height="534"
                        alt="oganic"
                    />
                </div>
                <div
                    class="col-md-6"
                    data-aos="fade-in"
                    data-wow-duration="1500"
                >
                    <div class="font-bold sub-title mb-4 mb-md-5">
                        Go Organic with <br />
                        MRT Organic
                    </div>
                    MRT Organic Green Products, most reliable and resourceful
                    international supplier of Natural Ingredients with decade of
                    expertise in Spices & Herbs, Essential oils, Spice
                    Oleoresin, Dehydrated Vegetables, Freeze Dried Vegetables &
                    Spices, Mints and Allied Products, Floral Concretes and
                    Absolutes backed with strong supply chain management both in
                    Raw Material and finished products.
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "Organic"
};
</script>
